export enum MfaEnrollmentStatus {
  Disabled = 0,
  Invited = 1,
  Accepted = 2,
  Enabled = 3,
}

export const mapMfaStatus = (status: string): string => {
  if (!status || MfaEnrollmentStatus[status] === undefined) {
    return MfaEnrollmentStatus[MfaEnrollmentStatus.Disabled];
  }

  if (
    status === MfaEnrollmentStatus[MfaEnrollmentStatus.Invited] ||
    status === MfaEnrollmentStatus[MfaEnrollmentStatus.Accepted]
  ) {
    return 'Pending';
  }

  return status;
};
